var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"#f5f5f5"}},[_c('v-main',[_c('Nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }